import React, { useState, useEffect } from "react";
import SelectList from "../../Components/Select";
import { callAPI } from "../../utils/callAPI";
import axios from "axios";
import { apiEndPoints } from "../../constants/apiEndPoints";
import DatePickerField from "../../Components/DatePickerField";
import TextArea from "../../Components/TextArea";
import "../Pages.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialProjectData = {
  departmentName: "",
  azureProjectName: "",
  monthCycle: "",
  // monthCycle: "",
  // year: new Date(),
  monthCycle: { value: "Oct-Dec", label: "Oct-Dec" },
  year: new Date(2023, 0, 1),
  date: "",
  architecture: "",
  approved: "",
  versionUpdate: "",
  comment: "",
};

const FormArchitectureApproval = (props) => {
  const [projectData, setProjectData] = useState(initialProjectData);
  const [showValidation, setShowValidation] = useState({
    departmentNameError: null,
    azureProjectNameError: null,
    // monthCycleError: null,
    architectureError: null,
    approvedError: null,
    versionUpdateError: null,
    commentError: null,
  });
  const [masterData, setMasterData] = useState({
    departments: [],
  });
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    const getDepartments = async () => {
      try {
        const allData = await axios.all([
          callAPI("GET", apiEndPoints.getDeptName),
        ]);
        if (allData && allData.length > 0) {
          const departments = allData[0].data.data;
          departments.forEach((item) => {
            item.value = item.departmentId;
            item.label = item.departmentName;
            delete item.departmentId;
            delete item.departmentName;
          });
          setMasterData({
            ...{ departments },
          });
        }
      } catch (error) {}
    };
    getDepartments();
    props.fetchArchitectureApproval();
  }, []);

  const handleProjectData = (val, key) => {
    setProjectData((previousData) => {
      return {
        ...previousData,
        [key]: val,
      };
    });
    setShowValidation((previousData) => {
      return {
        ...previousData,
        [`${key}Error`]: val ? false : true,
      };
    });
  };

  useEffect(() => {
    const getProjects = async () => {
      let projectList = [];
      if (projectData.departmentName) {
        const departmentName = projectData.departmentName.label;
        try {
          const resp = await callAPI(
            "GET",
            apiEndPoints.getProjName + "?departmentName=" + departmentName
          );
          projectList = resp.data.data;
          projectList.forEach((item) => {
            item.value = item.azureProjectId;
            item.label = item.azureProjectName;
            delete item.azureProjectId;
            delete item.azureProjectName;
            delete item.department;
          });
        } catch (err) {}
      }
      setProjectList(projectList);
    };
    getProjects();
  }, [projectData.departmentName]);

  const clearFormFields = () => {
    setProjectData(initialProjectData);
    setShowValidation(false);
  };
  const clearFormFieldsOnAdd = () => {
    setProjectData({
      departmentName: projectData.departmentName,
      azureProjectName: "",
      monthCycle: projectData.monthCycle,
      year: new Date(2023, 0, 1),
      date: "",
      architecture: "",
      approved: "",
      versionUpdate: "",
      comment: "",
    });

    setShowValidation((prev) => {
      return {
        ...prev,
        azureProjectNameError: null,
        architectureError: null,
        approvedError: null,
        versionUpdateError: null,
        commentError: null,
      };
    });
  };

  const validationHandler = () => {
    const data = Object.values(showValidation).every((item) => item === false);
    const data1 = { ...projectData };
    const data2 = { ...showValidation };

    for (const key in data1) {
      if (key !== "date" && data1[key] === "") {
        data2[`${key}Error`] = true;
      }
    }
    setShowValidation(data2);
    return data;
  };
  const handleSubmit = async () => {
    if (validationHandler() === false) {
      return false;
    }
    try {
      const employeeName = sessionStorage.getItem("employeeName");
      const response = await axios.post(apiEndPoints.addArchitectureApproval, {
        departmentId: projectData.departmentName.value,
        azureProjectId: projectData.azureProjectName.value,
        monthCycle: projectData.monthCycle.value,
        year: projectData.year.getFullYear(),
        architecture: projectData.architecture.value,
        approved: projectData.approved.value,
        date: projectData.date,
        versionUpdate: projectData.versionUpdate.value,
        comment: projectData.comment,
        username: employeeName,
      });
      // clearFormFields();
      clearFormFieldsOnAdd();
      // document.getElementById("exampleModalLong2").click();
      props.fetchArchitectureApproval();
      toast.success("Form submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage = error.response.data.message;
        alert(`${errorMessage}`);
      } else {
        console.error("Error submission", error);
      }
    }
  };

  return (
    <form
      className="modal fade bd-example-modal-lg"
      id="exampleModalLong2"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Architecture Approval
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                clearFormFields();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <SelectList
              ErrorStyle={showValidation.departmentNameError ? "invalid" : ""}
              label="Department Name"
              id="deptName"
              placeholder="Department Name"
              value={projectData.departmentName}
              onChange={(value) => {
                handleProjectData(value, "departmentName");
              }}
              options={masterData.departments}
              isSearchable={true}
            />
            <SelectList
              ErrorStyle={showValidation.azureProjectNameError ? "invalid" : ""}
              label="Project Name"
              id="Project"
              placeholder="Project Name"
              value={projectData.azureProjectName}
              onChange={(value) => {
                handleProjectData(value, "azureProjectName");
              }}
              options={projectList}
              isSearchable={true}
            />
            <DatePickerField
              id="projYear"
              label=" Year"
              showYearPicker
              dateFormat="yyyy"
              placeholderText="Select Year"
              selected={projectData.year}
              onChange={(date) => {
                handleProjectData(date, "year");
              }}
            />
          </div>
          <div className="modal-body">
            <SelectList
              ErrorStyle={showValidation.monthCycleError ? "invalid" : ""}
              label="Quarter"
              id="Quarter"
              placeholder="Quarter"
              options={["Jan-Mar", "Apr-Jun", "July-Sep", "Oct-Dec"]}
              defaultValue={{ value: "Oct-Dec", label: "Oct-Dec" }}
              value={projectData.monthCycle}
              onChange={(value) => handleProjectData(value, "monthCycle")}
            />
            <SelectList
              ErrorStyle={showValidation.architectureError ? "invalid" : ""}
              label="Architecture"
              id="architecture"
              placeholder="Architecture"
              options={["Yes", "No", "N/A"]}
              value={projectData.architecture}
              onChange={(value) => handleProjectData(value, "architecture")}
            />
            <SelectList
              ErrorStyle={showValidation.approvedError ? "invalid" : ""}
              label="Approved"
              id="approved"
              placeholder="Approved"
              options={["Yes", "No", "N/A"]}
              value={projectData.approved}
              onChange={(value) => handleProjectData(value, "approved")}
            />
          </div>
          <div className="modal-body">
            <DatePickerField
              id="date"
              label="Select Date"
              dateFormat="yyyy-MM-dd"
              placeholderText="Select Date"
              selected={projectData.date}
              onChange={(date) => {
                handleProjectData(date, "date");
              }}
            />
            <SelectList
              ErrorStyle={showValidation.versionUpdateError ? "invalid" : ""}
              label="Version Update"
              id="versionUpdate"
              placeholder="Version Update"
              options={["Yes", "No", "N/A"]}
              value={projectData.versionUpdate}
              onChange={(value) => handleProjectData(value, "versionUpdate")}
            />
            <TextArea
              ErrorStyle={showValidation.commentError ? "invalid" : ""}
              label="Comment"
              id="comment"
              rows={1}
              cols={20}
              value={projectData.comment}
              onChange={(e) => handleProjectData(e.target.value, "comment")}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-success btn-Add"
            >
              Add
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-dismiss="modal"
              onClick={() => {
                clearFormFields();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FormArchitectureApproval;
